import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skypointProvidersLoading: false,
  skypointProviders: null,
  skypointProvidersCount: 0,
  // Provider view (iframe) state
  activeProvider: null, // { id, name, token }
  // Provider module settings (Settings page) — shared so the list, add
  // drawer, edit form and documents module all read the same persisted
  // values without independently re-fetching.
  providerSettings: null,
  providerSettingsLoading: false,
};

export const skypointProvider = createSlice({
  name: "skypointProvider",
  initialState,
  reducers: {
    setSkypointProviderLoading(state, action) {
      return {
        ...state,
        skypointProvidersLoading: action?.payload,
      };
    },
    setSkypointProviders(state, action) {
      return {
        ...state,
        skypointProvidersLoading: false,
        skypointProviders: action?.payload?.providers,
        skypointProvidersCount: action?.payload?.count,
      };
    },
    setActiveProvider(state, action) {
      return {
        ...state,
        activeProvider: action?.payload,
      };
    },
    clearActiveProvider(state) {
      return {
        ...state,
        activeProvider: null,
      };
    },
    setProviderSettingsLoading(state, action) {
      return {
        ...state,
        providerSettingsLoading: action?.payload,
      };
    },
    setProviderSettings(state, action) {
      return {
        ...state,
        providerSettingsLoading: false,
        providerSettings: action?.payload,
      };
    },
  },
});

export const {
  setSkypointProviderLoading,
  setSkypointProviders,
  setActiveProvider,
  clearActiveProvider,
  setProviderSettingsLoading,
  setProviderSettings,
} = skypointProvider.actions;
export default skypointProvider.reducer;
